angular.module('Itao.IndicatorMap').directive('stackedGroupedSetBarChart', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var colors = [];
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var innerColor = function (d) {
    return accessor('color')(d);
  };

  var whiteToOpacity = function (d) {
    return d.color.toLowerCase() === '#ffffff' ? 0 : 1;
  };

  var offsetMappingFunction = function (propertyName) {
    return function (listObject, index, listArray) {
      // calculate the offset for each element in a list by the sum of the preceding elements
      listObject.offset = listArray.slice(0, index).reduce(function (sum, currentListObject) {
        return sum + currentListObject[propertyName];
      }, 0);
      return listObject;
    };
  };

  var sumMappingFunction = function (valuePropertyName, listPropertyName) {
    return function (listObject) {
      // only calculate sum if this has subElements
      if (listObject[listPropertyName] !== null) {
        // calculate the sum of a list by using the last offset and value
        var lastValue = listObject[listPropertyName][listObject[listPropertyName].length - 1];

        if (lastValue != null) {
          listObject.sum = lastValue.offset + lastValue[valuePropertyName];
        } else {
          listObject.sum = 0;
          console.warn('Last value in listObject not found:', listObject);
        }
      }
      return listObject;
    };
  };

  var combineData = function (layer, selectedIndicatorSet, disabledDistrictKeys, colorset, legend) {

    var lists = selectedIndicatorSet.lists
      .sort(function (a, b) {
        return a.listIndex - b.listIndex;
      }).map(function (list, index, allLists) {
        if (index === 0) {
          list.legendIndex = 0;
        } else {
          list.legendIndex = allLists[index - 1].indicators.length + allLists[index - 1].legendIndex + 1;
        }
        return list;
      });

    return Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function (districtUid) {
      return {
        // first level: districts
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        lists: lists.map(function (list, listIndex) {
          // second level: indicatorLists
          var subValues;

          var listName = list.title;
          if (legend != null) {
            if (legend.chart.scales.hasOwnProperty(list.legendIndex)) {
              listName = legend.chart.scales[list.legendIndex].text;
            } else {
              console.warn('Scale is missing index ' + list.legendIndex + ' using ' + listName + ' instead.');
            }
          }

          var scalesLength = legend.chart.scales.length;
          // get values for every indicator in the list
          subValues = list.indicators.map(function (indicator, index) {
            if (!layer[districtUid].hasOwnProperty(indicator.uid)) {
              return null;
            }
            // third level: values per indicator
            var valueLegendIndex = list.legendIndex + index + 1;
            var value = 0;
            if (layer[districtUid][indicator.uid] != null) {
              value = (+layer[districtUid][indicator.uid]);
            }

            var valueName = indicator.name;
            if (legend != null) {
              if (legend.chart.scales.hasOwnProperty(valueLegendIndex)) {
                valueName = legend.chart.scales[valueLegendIndex].text;
              } else {
                console.warn('Scale is missing index ' + list.legendIndex + '. Using ' + valueName + ' instead.');
              }
            }

            return {
              value: value,
              unit: indicator.unit,
              prefix: indicator.prefix,
              offset: 0,
              listName: listName,
              name: valueName,
              color: colorset[valueLegendIndex % colorset.length],
              legendIndex: valueLegendIndex,
              listIndex: listIndex,
              twinIndex: listIndex > 0 ? valueLegendIndex - (scalesLength/2) : valueLegendIndex + (scalesLength/2),
              barIndex: index,
              key: indicator.key
            };
          }).filter(function (value) {
            return value !== null;
          }).map(offsetMappingFunction('value'));

          return {
            name: listName,
            uid: list.uid,
            values: subValues
          };
        }).filter(function (list) {
          return list.values.length > 0;
        }).map(sumMappingFunction('value', 'values'))
      };
    });
  };

  var stackedGroupedSetBarChart = function () {
    var indicators = [],
      svgHeight = 200,
      displayValues = false,
      margin = {top: 40, right: 40, bottom: 30, left: 50},
      duration = 400,
      redLines,
      decimals,
      maxAxisValue,
      mouseOverFeature = null,
      tip;

    var chart = function (selection) {
      selection.each(function (data) {
        var yFormatter = germanNumberFormat(',.' + (decimals ? decimals : mapConfig.relativeIndicatorsDecimalPlaces) + '%');
        var yAxisFormatter = decimals ? yFormatter : germanNumberFormat("%");

        var container = d3.select(this).datum([data]);//.classed('stacked-set-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, i, j) {
            if (!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }
            var featureData = values[j].parentNode.parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.listName.replace('<br/>', '') + '<br>' + d.name.replace('<br/>', '').replace('<br>', '').trim() + ':</span> <span class="tooltip-value">' + d.prefix + ((d.unit === '%') ? yFormatter(d.value / 100) : (germanNumberFormat(',.' + decimals + 'f')(d.value) + ' (' + yFormatter(d.value / featureData.sum) + ')')) + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('.margin-group').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var featureScale = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.4)
          .domain(data.map(accessor('key')));

        var listScale = d3.scale.ordinal()
          .rangeRoundBands([0, featureScale.rangeBand()], 0.1)
          .domain(data[0].lists.map(accessor('uid')));

        var barScale = d3.scale.linear()
          .domain([0, 1])
          .range([height, 0]);

        var tickCount = Math.min(svgHeight / 40, 10);

        var yAxis = d3.svg.axis()
          .scale(barScale)
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicators[0].prefix + yAxisFormatter(d).replace('%', '');
          })
          .orient('left');

        var xAxis = d3.svg.axis()
          .scale(featureScale)
          .orient('bottom');

        g.call(d3.hyperion.addHorizontalGridLines(barScale, width, 0, tickCount, duration));

        redLines = redLines ? redLines : mapConfig.redLines;

        var lineScale = d3.scale.linear()
          .domain([0, 100])
          .range([height, 0]);

        g.call(d3.hyperion.addHorizontalHighlightArea(redLines, lineScale, featureScale, width, duration));

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis);

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (margin.left - 7) + ', 10)')
          .text('in %');

        function featureTransform(d) {
          return 'translate(' + featureScale(accessor('key')(d)) + ',0)';
        }

        var features = g.selectAll('.feature')
          .data(data, accessor('key'));

        features.enter()
          .append('g')
          .classed('feature', true)
          .attr('transform', featureTransform);

        features
          .transition().duration(duration)
          .attr('transform', featureTransform);

        features.exit().remove();

        var lists = features.selectAll('.list')
          .data(accessor('lists'), accessor('uid'));

        function listTransform(d) {
          return 'translate(' + listScale(accessor('uid')(d)) + ',0)';
        }

        lists
          .enter()
          .append('g')
          .attr('class', 'list')
          .attr('transform', listTransform);

        lists.transition().duration(duration)
          .attr('transform', listTransform);

        lists.exit().remove();

        var values = lists.selectAll('.value')
          .data(accessor('values'));

        values.enter()
          .append('rect')
          .attr('class', function (d, i,  j) {
            return "value " + d.key + ' focus-bar_' + d.legendIndex;
            //return "value " + d.key + ' focus-bar_' + (i+1);
            //return "value " + d.key + ' focus-bar_' + (d.barIndex+1);
          })
          .attr('x', 0)
          .attr('width', listScale.rangeBand())
          .attr('fill', innerColor)
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', 0);

        values.transition().duration(duration)
          .attr('fill', innerColor)
          .attr('fill-opacity', function (d, i, j) {
            if (mouseOverFeature !== null && (mouseOverFeature) !== d.legendIndex && (mouseOverFeature) !== d.twinIndex) {
              return 0;
            } else {
              return whiteToOpacity(d);
            }
          })
          .attr('y', function (d, i, j) {
            if (mouseOverFeature !== null) {
              return barScale(d.value / values[j].parentNode.__data__.sum);
            } else {
              return height - barScale(d.offset / values[j].parentNode.__data__.sum);
            }
          })
          .attr('height', function (d, i, j) {
            return height - barScale(d.value / values[j].parentNode.__data__.sum);
          })
          .attr('width', listScale.rangeBand());

        if (values.size() > 0) {
          values.call(tip);
          values.on('mouseover', function (d, i, j) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.show(d, i, j);
            }
          }).on('mouseout', function (d) {
            if (d.color.toLowerCase() !== '#ffffff') {
              tip.hide(d);
            }
          });
        }

        values.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        var labels = lists.selectAll('text')
          .data(accessor('values'));

        g.selectAll('line.highlightLine').remove();
        g.call(d3.hyperion.addHorizontalHighlightLines(redLines, lineScale, width, duration));


        // new labels
        labels.enter()
          .append('text')
          .attr('class', 'value-label hanging')
          .attr('y', 0);

        // update labels
        labels
          .attr("class", "chart-value")
          .text(function (d) {
            return d.value ? d.unit === '%' ? yFormatter(d.value / 100) : germanNumberFormat(',.' + decimals + 'f')(d.value) : '';
            //return germanNumberFormat('.' + mapConfig.absoluteIndicatorsDecimalPlaces + 'f')(accessor('value')(d));
          })
          .attr('fill-opacity', function (d, i, j) {
            if (!displayValues && mouseOverFeature !== null && (mouseOverFeature) !== d.legendIndex && (mouseOverFeature) !== d.twinIndex) {
              return 0;
            } else {
              return whiteToOpacity(d);
            }
          })
          .attr('y', function (d, i, j) {
            if (mouseOverFeature !== null) {
              return barScale(d.value / values[j].parentNode.__data__.sum) - 4;
            } else {
              return height - barScale(d.offset / values[j].parentNode.__data__.sum);
            }
            //return height - barScale(d.offset / values[j].parentNode.__data__.sum) + 12;
          })
          .attr('x', function (d, i) {
            // return (featureScale.rangeBand()/2) + (featureScale.rangeBand()* i);
            return (listScale.rangeBand() / 2);
          });

        // remove unused labels
        labels.exit()
          .remove();

      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     * getter/setter for mouseOverFeature
     * @param {Function} [newMouseOverFeature] new mouseOverFeature function
     * @returns {*}
     */
    chart.mouseOverFeature = function (newMouseOverFeature) {
      if (!arguments.length) {
        return mouseOverFeature;
      } else {
        mouseOverFeature = newMouseOverFeature;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    var content = element.closest('.grid-stack-item-content-stackedGroupedSetBarChart');
    return content.height() - jQuery(content).find('.selected-indicator-set').height() - jQuery(content).find('.no-indicator-set-selected').height() - 20;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'stackedGroupedSetBarChart.html',
    scope: {
      layer: '=',
      indicators: '=',
      colorsets: '=',
      indicatorSets: '=',
      disabledDistrictKeys: '=',
      dimensionX: '@',
      dimensionY: '@',
      mouseOverFeature: '=',
      config: '='
    },
    link: function (scope, element) {
      scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;

      var stackedGroupedSetBarChartFunction = stackedGroupedSetBarChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators;
        var redLines = null;
        var decimals,
          maxAxisValue;

        scope.selectedIndicatorSet = [];
        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function (color) {
                return color.color;
              });
              legend = scope.layer.legend[defaultIndicatorUid];

              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }
              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }
              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }
            }

            var data = combineData(scope.layer, scope.selectedIndicatorSet, scope.disabledDistrictKeys, colorset, legend);

            stackedGroupedSetBarChartFunction
              .indicators(indicators)
              .displayValues(scope.config.displayValues)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .mouseOverFeature(scope.mouseOverFeature)
              .height(newHeight);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data])
              .call(stackedGroupedSetBarChartFunction);
          } else {
            scope.config.selectedIndicatorSet = null;
            d3.select(element[0]).select('svg').remove();
          }
        }
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var mouseOverFeatureWatcher = scope.$watch('mouseOverFeature', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        mouseOverFeatureWatcher();

        // remove tooltip dom element
        if (angular.isDefined(stackedGroupedSetBarChartFunction.tip())) {
          stackedGroupedSetBarChartFunction.tip().destroy();
        }
      });
    }
  };
});
